// extracted by mini-css-extract-plugin
export default {"ads-container":"DoctorProfileAds_ads-container__G2owm","ad":"DoctorProfileAds_ad__hxuvC"};